import { MersTransferKind } from 'constants/loanActionEditor';

import { MersTransferDetailsFormTestIds } from './MersTransferDetailsForm.testIds';

export const SALE_ID_MAX_LENGTH = 30;

// MERS's date windows for a transfer initiation: any transfer at most 180 days ahead, a beneficial rights transfer
// (TOB) at most 60 days back.
export const TRANSFER_DAYS_AHEAD_LIMIT = 180;
export const BENEFICIAL_TRANSFER_DAYS_BACK_LIMIT = 60;

const ALL_TRANSFER_KINDS = Object.values(MersTransferKind);
const SERVICING_TRANSFER_KINDS = [
  MersTransferKind.SERVICING_RIGHTS,
  MersTransferKind.SERVICING_AND_BENEFICIAL_RIGHTS,
];

// The dates a transfer asks for and the transfer kinds each one applies to (flowKinds: the kinds it applies to on a
// flow transfer, when that differs — a flow servicing transfer carries no sale date). daysBackLimitKinds: the kinds
// whose date may be at most BENEFICIAL_TRANSFER_DAYS_BACK_LIMIT days back.
export const TRANSFER_DATE_FIELDS = [
  {
    name: 'effectiveDate',
    label: 'Transfer effective date',
    comboLabel: 'Servicing effective date',
    isRequired: true,
    kinds: ALL_TRANSFER_KINDS,
    isLimitedAhead: true,
    daysBackLimitKinds: [MersTransferKind.BENEFICIAL_RIGHTS],
    dataTestId: MersTransferDetailsFormTestIds.EFFECTIVE_DATE,
  },
  {
    name: 'beneficialEffectiveDate',
    label: 'Beneficial effective date',
    isRequired: true,
    kinds: [MersTransferKind.SERVICING_AND_BENEFICIAL_RIGHTS],
    isLimitedAhead: false,
    daysBackLimitKinds: [MersTransferKind.SERVICING_AND_BENEFICIAL_RIGHTS],
    dataTestId: MersTransferDetailsFormTestIds.BENEFICIAL_EFFECTIVE_DATE,
  },
  {
    name: 'saleDate',
    label: 'Sale date',
    isRequired: false,
    kinds: SERVICING_TRANSFER_KINDS,
    flowKinds: [MersTransferKind.SERVICING_AND_BENEFICIAL_RIGHTS],
    isLimitedAhead: false,
    daysBackLimitKinds: [],
    dataTestId: MersTransferDetailsFormTestIds.SALE_DATE,
  },
];

export const TRANSFER_CONFIRMATION_NOTE =
  'The transfer completes once the receiving member confirms it in MERS.';

export const TransferDateError = {
  TOO_FAR_AHEAD: `The transfer effective date may be at most ${TRANSFER_DAYS_AHEAD_LIMIT} days ahead`,
  TOO_FAR_BACK: `A beneficial rights transfer date may be at most ${BENEFICIAL_TRANSFER_DAYS_BACK_LIMIT} days back`,
  BEFORE_SALE_DATE: 'The transfer effective date must be on or after the sale date',
  AFTER_SERVICING_DATE:
    'The beneficial effective date must be on or before the servicing effective date',
};

export const SALE_ID_ONE_LINE_ERROR = 'The sale ID must be on one line';

// What MERS counts as a control character in a sale ID (.NET char.IsControl: U+0000–U+001F, U+007F–U+009F).
export const CONTROL_CHARACTER_REG_EXP = /\p{Cc}/u;
